export default {
  action: {
    openDialog: {
      notes: 'Open dialog activating beta features',
      message: 'Beta features',
    },
  },
  dialog: {
    header: {
      notes: 'Header in beta features dialog',
      message: 'Activated beta features',
    },
  },
  activeNotice: {
    notes: 'Notice that beta features are activated',
    message: 'Beta',
  },
};
